// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#sop-chat-slideout {
  position: fixed;
  top: 0;
  right: 0;
  width: 420px;
  height: 100%;
  z-index: 1060;
  display: flex;
  flex-direction: column;
  background: #1a1d23;
  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.3);
  animation: slideIn 0.25s ease-out;
}
@keyframes slideIn {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}
.chat-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  background: #12141a;
  border-bottom: 1px solid #2a2d35;
  flex-shrink: 0;
}
.chat-title {
  font-size: 14px;
  font-weight: 600;
  color: #e1e4e8;
}
.chat-title i {
  margin-right: 8px;
  color: #7c6df0;
}
.chat-actions {
  display: flex;
  gap: 4px;
}
.chat-action-btn {
  background: none;
  border: none;
  color: #8b949e;
  cursor: pointer;
  padding: 6px 8px;
  border-radius: 4px;
  font-size: 14px;
}
.chat-action-btn:hover {
  color: #e1e4e8;
  background: #2a2d35;
}
.chat-context {
  padding: 8px 16px;
  background: #1e2128;
  border-bottom: 1px solid #2a2d35;
  font-size: 12px;
  color: #7c6df0;
  flex-shrink: 0;
}
.chat-context i {
  margin-right: 4px;
}
.chat-messages {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.chat-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #484d56;
  text-align: center;
  gap: 12px;
}
.chat-empty p {
  font-size: 13px;
  max-width: 260px;
  line-height: 1.5;
}
.chat-message {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.chat-message.user .message-role {
  color: #58a6ff;
}
.chat-message.user .message-content {
  background: #1c3a5e;
  color: #c9d9eb;
  border-radius: 12px 12px 4px 12px;
  align-self: flex-end;
}
.chat-message.assistant .message-role {
  color: #7c6df0;
}
.chat-message.assistant .message-content {
  background: #22252d;
  color: #d1d5db;
  border-radius: 12px 12px 12px 4px;
}
.chat-message.error .message-role {
  color: #f85149;
}
.chat-message.error .message-content {
  background: #3d1a1a;
  color: #f0a8a8;
  border-radius: 12px;
}
.message-role {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 0 4px;
}
.message-role i {
  margin-right: 4px;
}
.message-content {
  padding: 10px 14px;
  font-size: 13px;
  line-height: 1.6;
  white-space: pre-wrap;
  word-wrap: break-word;
}
.message-sources {
  padding: 4px;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
}
.source-label {
  font-size: 11px;
  color: #484d56;
}
.source-tag {
  font-size: 11px;
  background: #2a2d35;
  color: #8b949e;
  padding: 2px 8px;
  border-radius: 10px;
}
.typing-indicator {
  display: inline-flex;
  gap: 4px;
  padding: 4px 0;
}
.typing-indicator span {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #484d56;
  animation: typing 1.2s infinite ease-in-out;
}
.typing-indicator span:nth-child(2) {
  animation-delay: 0.2s;
}
.typing-indicator span:nth-child(3) {
  animation-delay: 0.4s;
}
@keyframes typing {
  0%,
  60%,
  100% {
    transform: translateY(0);
    opacity: 0.4;
  }
  30% {
    transform: translateY(-4px);
    opacity: 1;
  }
}
.chat-input-area {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  padding: 12px 16px;
  background: #12141a;
  border-top: 1px solid #2a2d35;
  flex-shrink: 0;
}
.chat-input-area textarea {
  flex: 1;
  background: #22252d;
  border: 1px solid #2a2d35;
  border-radius: 8px;
  color: #d1d5db;
  padding: 10px 12px;
  font-size: 13px;
  font-family: inherit;
  resize: none;
  outline: none;
  max-height: 120px;
}
.chat-input-area textarea:focus {
  border-color: #7c6df0;
}
.chat-input-area textarea::placeholder {
  color: #484d56;
}
.chat-input-area textarea:disabled {
  opacity: 0.5;
}
.send-btn {
  background: #7c6df0;
  border: none;
  color: #fff;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 14px;
}
.send-btn:hover {
  background: #6c5ce7;
}
.send-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared-components-module/sop-chat-panel/sop-chat-panel.component.less"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,0CAAA;EACA,iCAAA;AACF;AAEA;EACE;IAAO,2BAAA;EACP;EAAA;IAAK,wBAAA;EAGL;AACF;AADA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;EACA,cAAA;AAGF;AAAA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAEF;AALA;EAIM,iBAAA;EAAmB,cAAA;AAKzB;AAFA;EACE,aAAA;EACA,QAAA;AAIF;AADA;EACE,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AAGF;AAFE;EAAU,cAAA;EAAgB,mBAAA;AAM5B;AAHA;EACE,iBAAA;EACA,mBAAA;EACA,gCAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;AAKF;AAXA;EAOM,iBAAA;AAON;AAJA;EACE,OAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAMF;AAHA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;AAKF;AAbA;EASM,eAAA;EAAiB,gBAAA;EAAkB,gBAAA;AASzC;AANA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAQF;AALA;EACkB,cAAA;AAOlB;AARA;EAGI,mBAAA;EACA,cAAA;EACA,iCAAA;EACA,oBAAA;AAQJ;AAJA;EACkB,cAAA;AAMlB;AAPA;EAGI,mBAAA;EACA,cAAA;EACA,iCAAA;AAOJ;AAHA;EACkB,cAAA;AAKlB;AANA;EAGI,mBAAA;EACA,cAAA;EACA,mBAAA;AAMJ;AAFA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;AAIF;AATA;EAMM,iBAAA;AAMN;AAHA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,qBAAA;AAKF;AAFA;EACE,YAAA;EACA,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;AAIF;AADA;EACE,eAAA;EACA,cAAA;AAGF;AAAA;EACE,eAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AAEF;AACA;EACE,oBAAA;EACA,QAAA;EACA,cAAA;AACF;AAJA;EAKI,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;AAEJ;AADI;EAAiB,qBAAA;AAIrB;AAHI;EAAiB,qBAAA;AAMrB;AAFA;EACE;;;IAAgB,wBAAA;IAA0B,YAAA;EAQ1C;EAPA;IAAM,2BAAA;IAA6B,UAAA;EAWnC;AACF;AATA;EACE,aAAA;EACA,qBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,cAAA;AAWF;AAlBA;EAUI,OAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;AAWJ;AAVI;EAAU,qBAAA;AAad;AAZI;EAAiB,cAAA;AAerB;AAdI;EAAa,YAAA;AAiBjB;AAbA;EACE,mBAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AAeF;AAdE;EAAU,mBAAA;AAiBZ;AAhBE;EAAa,YAAA;EAAc,mBAAA;AAoB7B","sourcesContent":["#sop-chat-slideout {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 420px;\n  height: 100%;\n  z-index: 1060;\n  display: flex;\n  flex-direction: column;\n  background: #1a1d23;\n  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.3);\n  animation: slideIn 0.25s ease-out;\n}\n\n@keyframes slideIn {\n  from { transform: translateX(100%); }\n  to { transform: translateX(0); }\n}\n\n.chat-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 16px;\n  background: #12141a;\n  border-bottom: 1px solid #2a2d35;\n  flex-shrink: 0;\n}\n\n.chat-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #e1e4e8;\n  i { margin-right: 8px; color: #7c6df0; }\n}\n\n.chat-actions {\n  display: flex;\n  gap: 4px;\n}\n\n.chat-action-btn {\n  background: none;\n  border: none;\n  color: #8b949e;\n  cursor: pointer;\n  padding: 6px 8px;\n  border-radius: 4px;\n  font-size: 14px;\n  &:hover { color: #e1e4e8; background: #2a2d35; }\n}\n\n.chat-context {\n  padding: 8px 16px;\n  background: #1e2128;\n  border-bottom: 1px solid #2a2d35;\n  font-size: 12px;\n  color: #7c6df0;\n  flex-shrink: 0;\n  i { margin-right: 4px; }\n}\n\n.chat-messages {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.chat-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  color: #484d56;\n  text-align: center;\n  gap: 12px;\n  p { font-size: 13px; max-width: 260px; line-height: 1.5; }\n}\n\n.chat-message {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.chat-message.user {\n  .message-role { color: #58a6ff; }\n  .message-content {\n    background: #1c3a5e;\n    color: #c9d9eb;\n    border-radius: 12px 12px 4px 12px;\n    align-self: flex-end;\n  }\n}\n\n.chat-message.assistant {\n  .message-role { color: #7c6df0; }\n  .message-content {\n    background: #22252d;\n    color: #d1d5db;\n    border-radius: 12px 12px 12px 4px;\n  }\n}\n\n.chat-message.error {\n  .message-role { color: #f85149; }\n  .message-content {\n    background: #3d1a1a;\n    color: #f0a8a8;\n    border-radius: 12px;\n  }\n}\n\n.message-role {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  padding: 0 4px;\n  i { margin-right: 4px; }\n}\n\n.message-content {\n  padding: 10px 14px;\n  font-size: 13px;\n  line-height: 1.6;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n\n.message-sources {\n  padding: 4px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  align-items: center;\n}\n\n.source-label {\n  font-size: 11px;\n  color: #484d56;\n}\n\n.source-tag {\n  font-size: 11px;\n  background: #2a2d35;\n  color: #8b949e;\n  padding: 2px 8px;\n  border-radius: 10px;\n}\n\n.typing-indicator {\n  display: inline-flex;\n  gap: 4px;\n  padding: 4px 0;\n  span {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: #484d56;\n    animation: typing 1.2s infinite ease-in-out;\n    &:nth-child(2) { animation-delay: 0.2s; }\n    &:nth-child(3) { animation-delay: 0.4s; }\n  }\n}\n\n@keyframes typing {\n  0%, 60%, 100% { transform: translateY(0); opacity: 0.4; }\n  30% { transform: translateY(-4px); opacity: 1; }\n}\n\n.chat-input-area {\n  display: flex;\n  align-items: flex-end;\n  gap: 8px;\n  padding: 12px 16px;\n  background: #12141a;\n  border-top: 1px solid #2a2d35;\n  flex-shrink: 0;\n\n  textarea {\n    flex: 1;\n    background: #22252d;\n    border: 1px solid #2a2d35;\n    border-radius: 8px;\n    color: #d1d5db;\n    padding: 10px 12px;\n    font-size: 13px;\n    font-family: inherit;\n    resize: none;\n    outline: none;\n    max-height: 120px;\n    &:focus { border-color: #7c6df0; }\n    &::placeholder { color: #484d56; }\n    &:disabled { opacity: 0.5; }\n  }\n}\n\n.send-btn {\n  background: #7c6df0;\n  border: none;\n  color: #fff;\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  font-size: 14px;\n  &:hover { background: #6c5ce7; }\n  &:disabled { opacity: 0.4; cursor: not-allowed; }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
